export function getBidSchema(range) {
  return {
    name: 'DefaultBid',
    type: 'object',
    properties: {
      Amount: {
        type: 'number',
        get maximum() {
          return range.bidCeil;
        },
        get minimum() {
          return range.bidFloor;
        },
        required: true,
      },
      required: [
        'Amount',
      ],
    },
  };
}

